(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    // One delegated listener for every stepper on the page — product form, cart
  // lines, anything added later.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-step]');
    if (!button) return;

    const input = button.closest('[data-quantity]')?.querySelector('[data-quantity-input]');
    if (!input) return;

    const min = Number(input.min) || 0;
    const current = parseInt(input.value, 10);
    const next = (Number.isNaN(current) ? min : current) + Number(button.dataset.quantityStep);

    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    // Delegated, so any number of size guides on a page work without wiring up.
  // Esc, the focus trap and the backdrop are the browser's job, not ours.
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.sizeGuideOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }

    if (event.target.closest('[data-size-guide-close]')) {
      event.target.closest('dialog')?.close();
      return;
    }

    // A click that lands on the dialog itself is a click on its backdrop —
    // the panel covers the whole of the dialog's own box.
    if (event.target.matches('dialog.size-guide')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
